// extracted by mini-css-extract-plugin
export var downArrow = "_jc-0";
export var infoTooltipIcon = "_jc-3";
export var label = "_jc-1";
export var optionCard = "_jc-4";
export var upArrow = "_jc-2";